import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@mui/material';

import OnDeleteIcon from '../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../icons/OnEditIcon';
import { reverseFormatDate } from '../../../utils/dateFunctions';
import { ADVISER, hasRole, MANAGER, QUALITY, SUPERUSER } from '../../../utils/userRoles';

import tables from '../../../commonStyles/tables.module.css';
import classes from '../questionnaire/questionnaire.module.css';

const deleteRoles = [MANAGER, QUALITY, SUPERUSER];
const linkRoles = [ADVISER, MANAGER, QUALITY];

const QuestionnaireRow = ({ row, roles, showForm, onEdit, onDelete, isDisabled }) => {
    return (
        <TableRow hover className={tables.basicRowStripes}>
            {row.timeCompleted === '' ? (
                <TableCell>{row.code}</TableCell>
            ) : hasRole(linkRoles, roles) && !showForm && !isDisabled ? (
                <TableCell
                    className={classes.questionnaireCodeLink}
                    onClick={(e) => onEdit(e, row)}
                    disabled={isDisabled}>
                    {row.code}
                </TableCell>
            ) : (
                <TableCell>{row.code}</TableCell>
            )}
            <TableCell>{row?.title || ' - '}</TableCell>
            <TableCell>{reverseFormatDate(row?.dateStarted) || ' - '}</TableCell>
            <TableCell>{reverseFormatDate(row?.dateCompleted) || ' - '}</TableCell>
            <TableCell>{row?.timeCompleted || ' - '}</TableCell>
            <TableCell>{row?.draft ? 'In-Progress' : 'Completed'}</TableCell>
            <TableCell align="right">
                {(row.draft || hasRole([SUPERUSER], roles)) && (
                    <OnEditIcon
                        onEdit={(e) => onEdit(e, row)}
                        active={!showForm && !isDisabled}
                        tooltip={
                            row.draft
                                ? 'Edit questionnaire'
                                : 'SUPERUSER can edit completed questionnaires'
                        }
                    />
                )}
            </TableCell>
            <TableCell align="right">
                {((row.draft && hasRole(deleteRoles, roles)) || hasRole([SUPERUSER], roles)) && (
                    <OnDeleteIcon
                        onDelete={() => onDelete(row)}
                        active={!showForm && !isDisabled}
                        tooltip={
                            row.draft
                                ? 'Delete questionnaire'
                                : 'SUPERUSER can delete completed questionnaires'
                        }
                    />
                )}
            </TableCell>
        </TableRow>
    );
};

QuestionnaireRow.propTypes = {
    row: PropTypes.object,
    roles: PropTypes.arrayOf(PropTypes.string),
    showForm: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    isDisabled: PropTypes.bool
};

export default QuestionnaireRow;
